import axios from 'axios';

async function userEmailSendLimit(method = 'email') {
  try {
    const sendEmailData = await axios.get('/user/remaining-emails/count', {
      params: { method },
    });
    return sendEmailData.data.remaining_emails;
  } catch (error) {
    return -1;
  }
}

async function userBroadcastSendRestriction(broadcastMethod) {
  try {
    if (broadcastMethod === 'email') {
      const broadcastSendRestriction = await axios.get('/plan/restriction');
      return broadcastSendRestriction.data;
    } else {
      return {
        can_sent_broadcast: 1,
        can_sent_broadcast_at: null,
        can_use_broadcast: 1,
        can_use_broadcast_at: null,
      };
    }
  } catch (error) {
    return {
      can_sent_broadcast: 1,
      can_sent_broadcast_at: null,
      can_use_broadcast: 1,
      can_use_broadcast_at: null,
    };
  }
}

export { userEmailSendLimit, userBroadcastSendRestriction };
